// extracted by mini-css-extract-plugin
module.exports = {"section-sub-title":"SectionSubTitle_section-sub-title__2TCVc"};